<template>
    <button :class="buttonClass" :type="type" :disabled="loading || disabled">
        <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
        <slot>Button</slot>
    </button>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';

export default defineComponent({
    props: {
        variant: {
            type: String,
            default: 'primary'
        },
        size: {
            type: String,
            default: '',
            validator: (value: string) => ['', 'sm', 'lg'].includes(value)
        },
        type: {
            type: String,
            default: 'button',
            validator: (value: string) => ['button', 'submit', 'reset'].includes(value)
        },
        disabled: { 
            type: Boolean, 
            default: false },
        loading: { 
            type: Boolean, 
            default: false }, // ✅ Nowy props do obsługi ładowania
    },
    setup(props) {
        const buttonClass = computed(() => [
            'btn',
            `btn-${props.variant}`,
            props.size ? `btn-${props.size}` : ''
        ]);

        return { buttonClass };
    }
});
</script>